const groupBy = <T>(
  array: ReadonlyArray<T> | undefined,
  callback: (arg0: T) => string | undefined
): { [index: string]: T[] } => {
  if (!array) return {};
  const res: { [index: string]: T[] } = {};
  for (const element of array) {
    const key = callback(element);
    if (key) res[key] ? res[key].push(element) : (res[key] = [element]);
  }
  return res;
};

export default groupBy;
